// 진형별 전열(front) 슬롯 번호 매핑
export const FORMATION_FRONT = {
  basic:   [1, 2],
  balance: [1, 2, 3],
  defense: [1],
  protect: [1, 2, 3, 4],
};

export const FORMATION_LABEL = {
  basic: '기본진형',
  balance: '밸런스진형',
  defense: '방어진형',
  protect: '보호진형',
};

export const isFrontSlot = (slotNo, formation) =>
  (FORMATION_FRONT[formation] || FORMATION_FRONT.basic).includes(slotNo);

// 라운드별 진형 조회 — formationR2/R3가 NULL이면 R1 진형 폴백
export const getFormationForRound = (guide, roundNo) => {
  if (!guide) return 'basic';
  if (roundNo === 2 && guide.formationR2) return guide.formationR2;
  if (roundNo === 3 && guide.formationR3) return guide.formationR3;
  return guide.formation || 'basic';
};

// 아군 목록을 라운드별로 그룹화
export const groupAlliesByRound = (allies) => {
  const byRound = {};
  (allies || []).forEach(a => {
    const r = a.roundNo || 1;
    if (!byRound[r]) byRound[r] = [];
    byRound[r].push(a);
  });
  return byRound;
};
